module.exports = __webpack_public_path__ + "img/55.d38b1295.jpg";